import React from 'react';
import PropTypes from 'prop-types';
import CodeEditorPanel from './CodeEditorPanel';

const WorkspacePanel = ({ codeEditorProps, workspaceError }) => (
  <div className="vibe-workspace-panel d-flex flex-column flex-grow-1 overflow-hidden min-w-0 h-100">
    {workspaceError ? (
      <div className="vibe-coding-workspace__error" role="alert">
        {workspaceError}
      </div>
    ) : (
      ''
    )}
    <CodeEditorPanel {...codeEditorProps} />
  </div>
);

WorkspacePanel.propTypes = {
  codeEditorProps: PropTypes.object.isRequired,
  workspaceError: PropTypes.string.isRequired,
};

export default WorkspacePanel;
